module.exports = [{"name":"PPARK420_FASTTRACK_FUNNEL_DESKTOP","version":1},{"name":"ppark-1873-fast-track-prime-pill","version":2}]